export const VeryLowRisk = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none"><path stroke="#1470CC" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m11 24 18-7" /><path stroke="#1470CC" stroke-dasharray="1 3" stroke-linecap="round" d="M9 9.5v21M31 9.5v21" opacity=".6" /></svg>
    )
}